import { createContext, useContext, type JSX } from 'solid-js';
import { VenueFonts } from 'Shared/model/venueSettings';


interface VenueFontsContext
{
	fonts: VenueFonts;
}

const FontsContext = createContext<VenueFontsContext>();

/*
	The fonts a 'Font family' dropdown offers. BackendWrap provides the venue document's; the Style
	Builder page provides its store's, so a font imported there is on offer straight away.
*/
export function VenueFontsProvider(P:{fonts:VenueFonts, children:JSX.Element})
{
	return (
		<FontsContext.Provider value={P}>
			{P.children}
		</FontsContext.Provider>
	);
}

export function useVenueFonts()
{
	return useContext(FontsContext) as VenueFontsContext;
}
